import HomePageConfigTypes from "Containers/HomePage/types"

const initialState = {
  pagePermission: null,
}

const HomePageConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case HomePageConfigTypes.GET_HOME_PAGE_PERMISSION_SUCCESS:
      return { ...state, pagePermission: action.payload }
    default:
      return state
  }
}

export default HomePageConfigReducer
